import { render, staticRenderFns } from "./contentUserGroupCreateChild.vue?vue&type=template&id=88442c04&"
import script from "./contentUserGroupCreateChild.vue?vue&type=script&lang=js&"
export * from "./contentUserGroupCreateChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports